module.exports = __webpack_public_path__ + "img/upArrowC.6377ffd1.svg";